var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"dn-margin-1"},[_c('img',{staticClass:"card-img-top",attrs:{"src":"https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E7%83%98%E5%B9%B2%E6%9C%BA/%E6%89%BF%E9%87%8D%E5%BA%95%E6%9D%BF%281%29.jpg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de5a864","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/czdb.vue
// module id = null
// module chunks = 